<template>
	<div class="distributor-account_group-list">
		<div class="common-header-wrap">
			<mt-header title="帐号组列表" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>
		<div class="pb-30" v-if="account_group_list.length>0">
			<div class="item mt-5" v-for="item in account_group_list" :key="item.sellergroup_id">
				<div class="div container">
					<div class="div account-info">
						<div class='seller_name'>
							<label class="subtitle">
								{{ item.sellergroup_name }}
							</label>
						</div>
						<div class="div button-wrapper">
							<div class="div edit-wrapper" @click="onEdit(item.sellergroup_id)">
								<div class="div common-btn btn-2">编辑</div>
							</div>
							<div class="div edit-wrapper delete-wrapper" @click="onDelete(item.sellergroup_id)">
								<div class="div common-btn btn-1">删除</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div  v-else>
			<empty-record></empty-record>
		</div>
		<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
	</div>
</template>

<script>

import { Toast, Indicator,MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getAccountGroupList, delAccountGroup } from '../../../api/sellerAccountGroup'
export default {
  components: {
    EmptyRecord
  },
  name: 'SellerAccountGroup',
  data () {
    return {
      account_group_list: []
    }
  },

  created: function () {
this.getAccountGroupList()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    goAdd () {
      this.$router.push({ name: 'SellerAccountGroupForm', query: { action: 'add' } })
    },

    onEdit (sellergroup_id) {
      this.$router.push({ name: 'SellerAccountGroupForm', query: { group_id: sellergroup_id } })
    },
    onDelete (sellergroup_id) {
      MessageBox.confirm('确定要取消该账号组吗？').then(action => {
      	delAccountGroup(sellergroup_id).then(res => {
      		if (res) {
      		  this.getAccountGroupList()
      		}
      	}).catch(function (error) {
      	  Toast(error.message)
      	})
      })
    },
    getAccountGroupList () {
		getAccountGroupList().then(res => {
        this.account_group_list = res.result.seller_group_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.item{background-color: #fff;}
.account-info {padding: .5rem 1rem 1.5rem;box-sizing: border-box;}
.account-info .lastlogin view{font-size: .7rem;color: #333;}
.account-info .lastlogin text{font-size: .7rem;color: #999;}
.account-info .seller_name {text-align: center;padding: 2rem 0 1rem;}
.account-info .seller_name .subtitle {font-size:1rem;color: #333;font-weight: bold;}
.account-info .button-wrapper {flex: 1;display: flex;flex-direction: row;justify-content: center;align-items: center;}
.account-info .button-wrapper .edit-wrapper{color: #fff;border-radius: 1.5rem;padding: .1rem .3rem;margin: 0 .2rem;background: $primaryColor;}
.account-info .button-wrapper .edit-wrapper .common-btn{color: #fff;padding:.5rem 3rem ;white-space: nowrap;}
.account-info .button-wrapper .delete-wrapper{background: #FB2630;}

</style>
